module.exports = __webpack_public_path__ + "static/media/0326_IMG_LES_ENSEIGNES_LE_POISSONNIER_LETTRE_A_LETTRE.7c70fe21.webp";